import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  IconButton,
  CircularProgress,
  Icon,
} from "@mui/material";
import "../css/FormAbsensi.css";
import axios from "axios";
import { API_URL } from "../api";
import { CustomModal } from "./CustomModal";

const FormForemanSection2 = ({ onComplete, onBack }) => {
  const [formData, setFormData] = useState({
    materi_safety_1: "",
    materi_safety_2: "",
    instruksi_kerja_1: "",
    instruksi_kerja_2: "",
    instruksi_kerja_3: "",
    instruksi_kerja_4: "",
    instruksi_kerja_5: "",
    instruksi_kerja_6: "",
    instruksi_kerja_7: "",
  });
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    title: "",
    message: "",
    type: "info",
    buttons: [],
  });

  const showModal = (title, message, type = "info", buttons = []) => {
    setModalConfig({ title, message, type, buttons });
    setModalVisible(true);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    if (!formData.materi_safety_1 || !formData.instruksi_kerja_1) {
      showModal(
        "Data Tidak Lengkap",
        "Materi Safety 1 dan Instruksi Kerja 1 wajib diisi.",
        "warning"
      );
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    setLoading(true);
    try {
      const form1 = JSON.parse(localStorage.getItem("foremanForm1"));
      if (!form1) {
        throw new Error(
          "Data dari langkah 1 tidak ditemukan. Harap ulangi dari awal."
        );
      }

      const foremanPayload = new FormData();

      // Gabungkan data dari form 1
      Object.entries(form1).forEach(([key, value]) => {
        if (value && key !== "foto") {
          foremanPayload.append(key, value);
        }
      });

      // Gabungkan data dari form ini (form 2)
      Object.entries(formData).forEach(([key, value]) => {
        if (value) foremanPayload.append(key, value);
      });

      // Proses foto dari form 1
      if (form1.foto && form1.foto.preview?.startsWith("blob:")) {
        const response = await fetch(form1.foto.preview);
        const fotoFile = await response.blob();
        foremanPayload.append(
          "foto",
          fotoFile,
          form1.foto.name || "foreman_photo.jpg"
        );
      }

      // Kirim ke API
      const response = await axios.post(
        `${API_URL}/foreman/absensi`,
        foremanPayload
      );

      if (response.status === 200 && response.data?.success !== false) {
        showModal("Berhasil", "Absensi P5M berhasil!", "success", [
          { text: "OK", onPress: () => window.history.back() },
        ]);
        localStorage.removeItem("foremanForm1");
      } else {
        throw new Error(response.data?.message || "Gagal mengirim data.");
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Terjadi kesalahan saat mengirim data.";
      showModal("Gagal", errorMessage, "error");
      console.error("Submit error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      <header className="app-header">
        <div className="header-content">
          <button className="back-button" onClick={onBack}>
            <Icon>arrow_back</Icon>
          </button>
          <h1 className="header-title"> Absensi Hadir P5M</h1>
          <div className="header-spacer"></div>
        </div>
      </header>
      <Box sx={{ p: 3 }}>
        <Paper sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Materi Safety
          </Typography>
          <TextField
            label="Materi Safety 1"
            fullWidth
            multiline
            rows={3}
            margin="normal"
            name="materi_safety_1"
            value={formData.materi_safety_1}
            onChange={handleChange}
            required
          />
          <TextField
            label="Materi Safety 2 (Opsional)"
            fullWidth
            multiline
            rows={3}
            margin="normal"
            name="materi_safety_2"
            value={formData.materi_safety_2}
            onChange={handleChange}
          />
        </Paper>

        <Paper sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Instruksi Kerja Harian
          </Typography>
          {[1, 2, 3, 4, 5, 6, 7].map((num) => (
            <TextField
              key={num}
              label={`Instruksi Kerja ${num}${num > 1 ? " (Opsional)" : ""}`}
              fullWidth
              multiline
              rows={2}
              margin="normal"
              name={`instruksi_kerja_${num}`}
              value={formData[`instruksi_kerja_${num}`]}
              onChange={handleChange}
              required={num === 1}
            />
          ))}
        </Paper>

        <Button
          variant="contained"
          fullWidth
          size="large"
          onClick={handleSubmit}
          disabled={
            loading || !formData.materi_safety_1 || !formData.instruksi_kerja_1
          }
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "Kirim"}
        </Button>
      </Box>

      {/* Modal */}
      <CustomModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        title={modalConfig.title}
        message={modalConfig.message}
        type={modalConfig.type}
        buttons={modalConfig.buttons}
      />
    </div>
  );
};

export default FormForemanSection2;
